<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <p-tabView>
      <p-tabPanel header="Upload Files">
        <div class="card cost-api-card" style="padding: 2rem; margin-left: 1rem;">
          <p style="font-weight:bold">Sales and Volume: </p>
          <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
            <div class="row">
              <div class="text-center col-sm-6 col-md-6 col-lg-4">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="customFile" name="myfile"
                    (change)="onFileSelect($event)" #UploadFileInput>
                  <label class="custom-file-label" for="customFile">{{fileInputLabel || 'Choose File'}}</label>
                </div>
              </div>
              <div class="text-center">
                <button class="btn btn-primary" type="submit"><i class="fa fa-upload mr-2"></i>Upload</button>
              </div>
            </div>
          </form>
          <div class="row upload-files" style="margin-top: 20px;">
            <div class="col-lg-3">
              <h6>Generic name</h6>
              <p-dropdown [options]="genericNames" optionLabel="name" [(ngModel)]="selectedGenericName"
                placeholder="Select generic name" [filter]="true" filterBy="name"
                (onChange)="getBrandnames()"></p-dropdown>
            </div>
            <div class="col-lg-3">
              <h6>Brand name</h6>
              <p-dropdown [options]="brandName" optionLabel="name" [(ngModel)]="selectedBrandName"
                placeholder="Select brand name" (onChange)="getROA()"></p-dropdown>
            </div>
            <div class="col-lg-3">
              <h6>Route of administration</h6>
              <p-dropdown [options]="roa" optionLabel="name" [(ngModel)]="selectedroa"
                placeholder="Select route of administration" (onChange)="getDosageNames()"></p-dropdown>
            </div>
            <div class="col-lg-3">
              <h6>Dosage</h6>
              <p-dropdown [options]="dosageList" optionLabel="name" [(ngModel)]="selecteddosage"
                placeholder="Select dosage" (onChange)="getNature()"></p-dropdown>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-lg-3">
              <h6>Nature</h6>
              <p-dropdown [options]="natureList" optionLabel="name" [(ngModel)]="selectednature"
                placeholder="Select nature" (onChange)="getStrength()"></p-dropdown>
            </div>
            <div class="col-lg-6">
              <h6>Strength</h6>
              <p-dropdown [options]="strength" optionLabel="name" [(ngModel)]="selectedstrength"
                placeholder="Select strength"></p-dropdown>
              <button type="button" class="btn btn-primary" style="margin-left:10px;"
                (click)="getSaleAndVolumeTable()">Submit</button>
            </div>
          </div>

          <div *ngIf="showTable">
            <button type="button" style="float: right; margin-top:20px; margin-bottom:20px;" (click)="editbtn()"><i
                class="fa fa-edit mr-2"></i>Edit</button>


            <div class="row table-responsive"
              style="margin-top: 20px; width:85rem !important; height: 800px !important;">
              <table class="table table-striped table-bordered text-center sales-table">
                <thead>
                  <tr>
                    <th *ngFor="let headers of salesVolumeData | tableHeaders" id="innertableheader"
                      style="width: auto;">
                      <p>{{headers}}</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let trows of salesVolumeData | tableBody;let m=index">
                    <td *ngFor="let rdata of trows;let iindex =index" style="width: auto;">
                      <p [ngClass]="[!showedit ?'editcls':'editdisable']">{{rdata}}</p>
                      <input type="text" [ngClass]="[showedit ?'editcls':'editdisable']"
                        (change)="editdata($event,headers,salesVolumeData,m,iindex)" value="{{rdata }}" id={{rdata}}>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>

              <button type="button" class="btn btn-primary" style="margin-left:10px;float: right;margin-top: 20px;"
                (click)="updateSalesAndVolume()" [disabled]="salesUpdateButton">Update sales and volume</button>
              <button type="button" class="btn btn-primary" style="float: right;
            margin-right: 20px; margin-top: 20px;" (click)="editSalesAndVolume($event)">Save</button>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>


    <!-- PER DAY DOSAGE FOR PATIENTS -->

    <p-tabView>
      <p-tabPanel header="Per day dosage for patient">
        <div class="card cost-api-card perday-dosage" style="padding: 2rem; margin-left: 1rem;">
          <div>
            <button style="width: 100px;" class="btn btn-primary float-right" (click)="resetPDD()">reset</button>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-lg-4">
              <h6>Generic name</h6>
              <p-dropdown [options]="pddGenericName" optionLabel="name" [(ngModel)]="selectedpddGenericName"
                placeholder="Select generic name" [filter]="true" filterBy="name"
                (onChange)="getpddBrandNames()"></p-dropdown>
            </div>
            <div class="col-lg-4">
              <h6>Brand name</h6>
              <p-dropdown [options]="pddbrandName" optionLabel="name" [(ngModel)]="selectedpddBrandName"
                placeholder="Select brand name" (onChange)="getpddNDA()"></p-dropdown>
            </div>
            <div class="col-lg-4">
              <h6>NDA</h6>
              <p-dropdown [options]="pddNDA" optionLabel="name" [(ngModel)]="selectedpddNDA"
                placeholder="Select NDA"></p-dropdown>
            </div>

          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-lg-4">
              <h6>Times (days)</h6>
              <input type="text" [(ngModel)]="enteredTimes" style="width: 100%;">
            </div>
            <div class="col-lg-4">
              <h6>Samples</h6>
              <input type="text" [(ngModel)]="enteredSamples" style="width: 100%;">
              <!-- <button type="button" class="btn btn-primary" style="margin-left:100px;" (click)="submitPDD()">Submit</button> -->
            </div>
            <div class="col-lg-4">
              <button type="button" class="btn btn-primary" style="margin-top:25px;"
                (click)="submitPDD()">Submit</button>
            </div>

          </div>
        </div>
      </p-tabPanel>
    </p-tabView>


  </div>

</div>